// extracted by mini-css-extract-plugin
export default {"container":"WhatIsAStep_container__EYkqZ","description":"WhatIsAStep_description__05WhI"};